import React from 'react';
import { ButtonMainContainerStyle } from './style';
import { Link } from 'react-router-dom';

function ButtonMainContainer({ type, color, name, link, linkImg, target, yourFunction }) {
  return (
    <ButtonMainContainerStyle color={color}>
      {type === 'button' && (
        <Link to={link}>
          <img src={linkImg} alt={name} />
          <span>{name}</span>
        </Link>
      )}
      {type === 'link' && (
        <a href={link} target={target}>
          <img src={linkImg} alt={name} />
          <span>{name}</span>
        </a>
      )}
      {type === 'modal' && (
        <button onClick={yourFunction}>
          <img src={linkImg} alt={name} />
          <span>{name}</span>
        </button>
      )}
    </ButtonMainContainerStyle>
  );
}

export default ButtonMainContainer;
